// import './App.css';
import Header from './pages/header/header';
import Footer from './pages/footer/footer';
import Body from './pages/body/body';

function App() {
  return (
    <div className="App">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default App;
